/** Pixen Intrigue — English overrides for the Play / VTT feature. Courtly-fae voice. */
export const playPixEn = {
  // CampaignList
  'play.campaigns.loading': 'Recalling your intrigues…',

  // CampaignPage — VTT prototype
  'play.vtt.iframeTitle': 'Pixen Intrigue VTT — campaign {campaignId}',
  'play.vtt.veilHeadline': 'The glamour between table and tale is thin here.',

  // CampaignPage — encyclopedia sidebar
  'play.codex.searching': 'Consulting the Archive…',
  'play.codex.hint': 'Type at least two letters to search the Court archive without leaving your table.',

  // CharacterSheet
  'play.sheet.savedToCodex': 'Recorded in the Archive.',
  'play.sheet.unclaimedHero': 'Unclaimed courtier',
  'play.sheet.backstoryPlaceholder': 'What favor do you owe, and to whom?',
  'play.sheet.canonCandidateHint':
    'Opt this character in for consideration as part of the living Pixen Intrigue canon.',

  // CreateGameModal
  'play.create.errorCreate': 'The invitation was refused — your table could not be created. Try again shortly.',
  'play.create.modalTitle': 'Convene a Salon',
  'play.create.successCopy': 'Your table is set. Share this invite to draw more courtiers to your side.',
  'play.create.tableNamePlaceholder': 'e.g. The Midnight Masquerade',
  'play.create.systemDefault': 'Pixen Intrigue (default)',

  // JoinPage
  'play.join.defaultTableTitle': 'A Pixen Intrigue table',

  // PlayLobbyPage
  'play.lobby.seoDescription':
    'Find a table, join a live session, and scheme your way through the courts of the fae at the Pixen Intrigue virtual tabletop.',
  'play.lobby.subtitle':
    'Gather your allies. Trade your secrets. Take your seat at a table where every whisper carries weight and every favor is remembered.',

  // SessionListLive
  'play.live.empty': 'No tables are live at this hour. The Court is quiet — convene your own.',

  // TableList — empty board
  'play.tables.emptyBody':
    'The salon is quiet for now. Be the first to pull up a chair — try the guest table instantly, no account needed.',
}
